import React from "react";
import Header from "../Header/Header";
import BacktoTop from "../../Components/BacktoTop";

import HoverPage from "../HoverPage/HoverPage";
import Page1 from "../Page1/page1";
import Page2 from "../Page2-new/page2";
import Page3 from "../Page3/page3";
import Page4 from "../Page4/page4";
import Page5 from "../Page5/page5";
import Page6 from "../Page6/page6";
import Page7 from "../Page7/page7";
import Page8 from "../Page8/page8";
import shade from "../../images/shadeImage.svg";
import Footer from "../../Components/Footer/Footer";

export default function LayoutPage() {
  return (
    <div>
      {" "}
      <Header />
      {/* <div className="mainwrapper"> */}
      <Page1 />
      {/* </div> */}
      <Page2 />
      <Page3 />
      <Page4 />
      <Page5 />
      <HoverPage />
      <Page6 />
      <Page7 />
      <Page8 />
      <Footer />
      <BacktoTop />
    </div>
  );
}
